<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="center"><img alt="image" src="images/p4-5.jpg"/></p>
<p class="toc"><a href="#/cap00b"><span class="bold">A New Approach to Eating</span></a></p>
<p class="toc"><a href="#/cap01"><span class="bold">Almost Meatless</span></a></p>
<p class="toc"><span href="#/cap02" title="Link target outside of Sample"><span class="bold">Seafood</span></span></p>
<p class="toc"><span href="#/cap03" title="Link target outside of Sample"><span class="bold">Poultry</span></span></p>
<p class="toc"><span href="#/cap04" title="Link target outside of Sample"><span class="bold">Meat</span></span></p>
<p class="toc"><span href="#/cap05" title="Link target outside of Sample"><span class="bold">Desserts</span></span></p>
<p class="toc"><span href="#/cap06" title="Link target outside of Sample"><span class="bold">Tips for Living Gluten Free</span></span></p>
<p class="start2"></p>
<p class="toc"><span href="#/cap07" title="Link target outside of Sample"><span class="bold">Basic Recipes</span></span></p>
<p class="toc"><span href="#/cap08" title="Link target outside of Sample"><span class="bold">Sources</span></span></p>
<p class="toc"><span href="#/index" title="Link target outside of Sample"><span class="bold">Index</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?18ff204c